module.exports = __webpack_public_path__ + "img/top_carousel_01.acab8090.jpg";